// 20.2.2.12 Math.cosh(x)
var $export = require('./$.export')
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/es6.math.cosh.js
 ** module id = 499
 ** module chunks = 0 1 4 5 6 7 8
 **/